import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { IconComponent } from 'src/app/ui/icon/icon.component';
import { SharedDialogComponent, SharedDialogOptions } from 'src/app/ui/shared-dialog/shared-dialog.component';
import { getQuotationStatusStyles } from 'src/app/shared/utils/quotation-status-styles';
import { ISegregationSplit } from '../../models/quotations.models';

/** Linked orders rendered inline on the detail page; past it, a counter opens this modal. */
export const LINKED_ORDERS_INLINE_MAX = 3;

export interface ILinkedOrdersModalData {
  orderName: string;
  splits: ISegregationSplit[];
}

@Component({
  selector: 'app-linked-orders-modal',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, IconComponent, SharedDialogComponent],
  templateUrl: './linked-orders-modal.component.html',
  styleUrls: ['./linked-orders-modal.component.scss'],
})
export class LinkedOrdersModalComponent {
  /** Rows are the only action here, so the confirm/cancel bar is suppressed. */
  readonly dialogOptions: SharedDialogOptions;

  constructor(
    private dialogRef: MatDialogRef<LinkedOrdersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ILinkedOrdersModalData,
    translate: TranslateService,
  ) {
    this.dialogOptions = {
      titleIcon: 'split',
      subTitle: translate.instant('quotations_and_orders.segregation.linked_orders_subtitle', {
        count: this.splits.length,
        orderName: data.orderName,
      }),
      size: 'medium',
      hideActions: true,
    };
  }

  get splits(): ISegregationSplit[] {
    return this.data.splits ?? [];
  }

  statusStyles(status: string | null | undefined): { [key: string]: string } {
    return getQuotationStatusStyles(status ?? '');
  }

  trackById(_index: number, split: ISegregationSplit): number {
    return split.id;
  }

  close(): void {
    this.dialogRef.close();
  }
}
